export default {
    namespaced: true,
    state: {
        mo_id: 0,
        mo_hash: null,
        cart: [],
        orderDetails: {
            profile_id: 0,
            paymentMethod: 2,
            iTransfer: '',
            subscriber_id: null
        },
        previousPaymentMethod: null,
        previousOrderDetails: {
            order_id: null,
            value: null
        },
        productsWithErrors: [],
        editProduct: null,
        editProductIndex: null,
        orderHasVignetteProducts: false,
        orderHasTollProducts: false
    },
    mutations: {
        resetOrderHasTollAndVignette(state) {
            state.orderHasVignetteProducts = false;
            state.orderHasTollProducts = false;
        },

        addToCart(state, item) {
            if(item.type == 'vignette') {
                state.orderHasVignetteProducts = true;
            }

            if(item.type == 'toll') {
                state.orderHasTollProducts = true;
            }

            if(!state.editProduct) {
                state.cart.push(item);
            }
            else {
                state.cart.splice(state.editProductIndex, 1, item);
            }
        },

        addToProductsWithErrors(state, item) {
            state.productsWithErrors.push(item);
        },

        saveMOID(state, id) {
            state.mo_id = id;
        },

        saveMOHash(state, hash) {
            state.mo_hash = hash;
        },
        savePreviousPaymentMethod(state) {
            state.previousPaymentMethod = state.orderDetails.paymentMethod;
        },
        resetCart(state) {
            state.mo_id = 0;
            state.mo_hash = null;
            state.cart = [];
            state.orderDetails = {
                profile_id: 0,
                paymentMethod: 2,
                iTransfer: '',
                subscriber_id: null
            };
            state.productsWithErrors = [];
        },

        removeItemFromCart(state, index) {
            state.cart.splice(index, 1);
        },

        changeMethod(state, method) {
            state.orderDetails.paymentMethod = method;
        },

        changeiTransfer(state, method) {
            state.orderDetails.iTransfer = method;
        },

        setProfileId(state, id) {
            state.orderDetails.profile_id = id;
        },

        setProfileSubscriberId(state, id) {
            state.orderDetails.subscriber_id = id;
        },

        saveCart(state, cart) {
            state.cart = cart;
        },

        saveCartErrors(state, cartWithErrors) {
            state.productsWithErrors = cartWithErrors;
        },

        setEditProduct(state, index) {
            state.editProduct = state.cart[index];
            state.editProductIndex = index;
        },

        resetEditProduct(state) {
            state.editProduct = null;
            state.editProductIndex = null;
        },

        savePreviousOrderDetailsForAnalytics(state, order) {
            state.previousOrderDetails.order_id = order.order_id;
            state.previousOrderDetails.value = order.value;
        }
    },
    actions: {
        editProduct({commit}, index) {
            commit('setEditProduct', index);
        },

        resetEditProduct({commit}) {
            commit('resetEditProduct');
        },

        addToCart(context, item) {
            context.commit('addToCart', item);
        },

        addToProductsWithErrors({commit}, item) {
            commit('addToProductsWithErrors', item);
        },

        saveMOID({commit}, id) {
            commit('saveMOID', id);
        },

        saveMOHash({commit}, hash) {
            commit('saveMOHash', hash);
        },

        resetCart(context) {
            context.commit('resetCart');
        },

        removeItemFromCart(context, index) {
            context.commit('removeItemFromCart', index);

            if(!context.state.cart.length) {
                context.commit('resetCart');
            }
        },

        changeMethod({commit}, method) {
            commit('changeMethod', method);
            commit('savePreviousPaymentMethod');
        },

        changeiTransfer({commit}, method) {
            commit('changeiTransfer', method);
        },

        setProfileId({commit}, id) {
            commit('setProfileId', id);
        },

        setProfileSubscriberId({commit}, id) {
            commit('setProfileSubscriberId', id);
        },

        placeOrder({commit, getters, rootState}) {
            let payload = {
                mo_id: getters.getOrderID,
                mo_hash: getters.getOrderHash,
                cart: getters.getCart,
                details: getters.getOrderDetails,
                browser_info: {
                    colorDepth: screen.colorDepth,
                    screenWidth: screen.width,
                    screenHeight: screen.height,
                    timezone: (new Date()).getTimezoneOffset()
                },
            };

            if(!rootState.auth.isLoggedIn) {
                payload.profile = rootState.profiles.tmpProfile;
            }

            if(rootState.auth.isLoggedIn) {
                payload.saveCard = rootState.payuTokens.saveCard;
                payload.tokenId = rootState.payuTokens.tokenId;
            }

            let recaptchaToken = rootState.recaptcha.token;
            let recaptchaVersion = rootState.recaptcha.type;

            return this.$axios
                .post('/orders', payload, {
                    headers: {
                        [`G-Recaptcha-${recaptchaVersion}-Token`]: recaptchaToken
                    }
                })
                .then(response => {
                    return response;
                });
        },

        saveCart({commit}, cart) {
            commit('saveCart', cart);
        },

        saveCartErrors({commit}, cartWithErrors) {
            commit('saveCartErrors', cartWithErrors);
        },

        checkIfProductHasActiveVignette(context, payload) {
            return this.$axios.post('/vehicles/check-vehicle-active-existing-vignettes', payload).then(response => {
                return response;
            });
        },

        savePreviousOrderDetailsForAnalytics({commit}, order) {
            commit('savePreviousOrderDetailsForAnalytics', order);
        },

        resetOrderHasTollAndVignette({ commit }) {
            commit('resetOrderHasTollAndVignette');
        }
    },
    getters: {
        orderHasVignetteProducts: ({ orderHasVignetteProducts }) => {
            return orderHasVignetteProducts;
        },

        orderHasTollProducts: ({ orderHasTollProducts }) => {
            return orderHasTollProducts;
        },

        getEditProduct: ({editProduct}) => {
            return editProduct;
        },

        getEditProductIndex: ({editProductIndex}) => {
            return editProductIndex;
        },

        getOrderID: (state) => {
            return state.mo_id;
        },

        getOrderHash: (state) => {
            return state.mo_hash;
        },

        getProductsWithErrors: (state) => {
            return state.productsWithErrors;
        },

        getCart: (state) => {
            return state.cart;
        },

        getCartWithErrors: (state) => {
            return state.productsWithErrors;
        },

        getOrderDetails: (state) => {
            return state.orderDetails;
        },

        cartCount: (state) => {
            return state.cart.length;
        },

        getPreviousPaymentMethod: ({previousPaymentMethod}) => {
            return previousPaymentMethod;
        },

        getPreviousOrderDetails: ({previousOrderDetails}) => {
            return previousOrderDetails;
        },

        cartTollTotal: (state, getters) => {
            var total = 0;

            for (var i = 0; i < getters.cartCount; i++) {
                if(state.cart[i].type == 'toll') {
                    total += parseFloat(state.cart[i].price);
                }
            }

            return total;
        },

        cartVignetteTotal: (state, getters) => {
            var total = 0;

            for (var i = 0; i < getters.cartCount; i++) {
                if(state.cart[i].type == 'vignette') {
                    total += parseFloat(state.cart[i].price);
                }
            }

            return total;
        },

        cartTotal: (state, getters, _, rootGetters) => {
            var total = 0;

            for (var i = 0; i < getters.cartCount; i++) {
                if(typeof state.cart[i].price === 'number') {
                    total += state.cart[i].price;
                }
                else {
                    total += parseFloat(state.cart[i].price.replace(',', ''));
                }
            }

            return Math.round((total + Number.EPSILON) * 100) / 100;
        },

        cartSMSTotal: (state, getters, _, rootGetters) => {
            var total = 0;

            for (var i = 0; i < getters.cartCount; i++) {
                if(rootGetters['settings/getSmsSetting'] != null) {
                    if(state.cart[i].sms_confirm_notification) {
                        total += parseFloat(rootGetters['settings/getSmsSetting'].value);
                    }
    
                    if(state.cart[i].sms_expiry_notification) {
                        total += parseFloat(rootGetters['settings/getSmsSetting'].value);
                    }
                }
            }

            return Math.round((total + Number.EPSILON) * 100) / 100;
        },
    }
}
